<template>
  <loader v-if="loading"></loader>
  <load-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :cancel-button="true"
    :remove-button="$route.params.id !== 'new'"
    :edit-button="!editing"
    :save-button="editing"
    remove-confirm-message="Vuoi veramente eliminare questo tipo di analisi?"
    @cancel="cancel"
    @remove="remove"
    @edit="edit"
    @save="save">
    <analysis-type
      :value="instance"
      :errors="errors"
      :disabled="!editing"
      @input="instance = $event"
    />
    <debug-panel slot="debug">{{ instance }}</debug-panel>
  </load-page-layout>
</template>
<script>
import AnalysisTypeService from 'app/services/AnalysisTypeService';
import LoadPageMixin from 'vue-core/mixins/LoadPageMixin';

export default {
  mixins: [ LoadPageMixin ],

  created() {
    this.service = AnalysisTypeService;
  },

  computed: {
    breadcrumbs() {
      if (!this.instance) {
        return [];
      }
      
      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Tipi di analisi',
          link: '/protected/analysis-types'
        },
        {
          label: this.$route.params.id === 'new'
              ? '<Nuovo>'
              : (this.instance && this.instance.id || '<Tipo di analisi>')
        }
      ];
    },
  },

  methods: {
    cancel() {
      if (!this.instance.id || !this.editing) {
        this.$router.push({
          name: 'Analysis-types'
        });
      } else {
        this.unedit();
      }
    },

    onRemoveSuccess({ statusCode, data}) {
      this.$router.push({
        name: 'Analysis-types'
      });
    },
  }
};
</script>
